// 集中管理 API 相關設定
// VITE_APP_API_URL 為 server root，例如 https://api.msg.nogi46.me

export const STATIC_URL = import.meta.env.VITE_APP_API_URL;
export const API_URL = `${import.meta.env.VITE_APP_API_URL}/api/v2`;
